import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { HttpErrorHandlerContribution } from '@patsnap/tahiti-core/common/http-error-handler-contribution';
import { bindContributionProvider } from '@patsnap/tahiti-core/common/contribution-provider';
import { Message } from '@patsnap/tahiti-core/common/message';
import { OpenService, OpenServiceImpl } from '@patsnap/tahiti-core/services/open-service';
import { Toast } from 'patsnap-biz';
import { i18n } from '@/infrastructure/locales';
import psHttp, { psHttp$ } from '@patsnap/common-ps-http';
import { PsHttp } from '@patsnap/tahiti-core/common/ps-http';
import { PsHttp$, PsHttpChannel, PsHttpChannelImpl } from '@patsnap/tahiti-core/common/http-channel';
import { ErrorHandlerContribution, ErrorHandlerRegistry, ErrorHandlerRegistryImpl } from '@patsnap/tahiti-core/common/error-handler-contribution';
import { I18nOrigin, I18nService } from '@/services/i18n-service';
import { TrizErrorHandler } from '@/infrastructure/error-handler/triz-error-handle';
import { ErrorHandler, ErrorHandlerImpl } from '@patsnap/tahiti-core/common/error-handler';
import { Logger } from '@patsnap/tahiti-core/common/logger';
import { RouterService } from '@eureka/shared/core-services/src/vue-router-service';
import router from '@/routers';
import { SSEPsHttpImpl, FactoryPsHttpSSE, PsHttpSSE } from '@patsnap-utils/sse';

export const baseModule = new ContainerModule((bind) => {
    bind(I18nOrigin).toConstantValue(i18n);
    bind(I18nService).toConstantValue({
        t: i18n.global.t.bind(i18n),
        te: i18n.global.te.bind(i18n),
        locale: i18n.global.locale.value,
    });
    bindContributionProvider(bind, HttpErrorHandlerContribution);
    bind(Logger).toConstantValue(console);
    bind(PsHttp).toConstantValue(psHttp);
    bind(PsHttp$).toConstantValue(psHttp$);
    bind(PsHttpChannel).to(PsHttpChannelImpl);
    bind(Message).toConstantValue(Toast);
    bind(OpenService).to(OpenServiceImpl);
    bind(ErrorHandler).to(ErrorHandlerImpl);
    bind(ErrorHandlerRegistry).to(ErrorHandlerRegistryImpl);
    bindContributionProvider(bind, ErrorHandlerContribution);
    bind(ErrorHandlerContribution).to(TrizErrorHandler);
    bind(RouterService).toConstantValue(router);
    bind(PsHttpSSE).to(SSEPsHttpImpl).inRequestScope();
    bind(FactoryPsHttpSSE).toDynamicValue(context => () => context.container.get(PsHttpSSE));
});
